<template>
    <section class="countdown">
        <circles-layout :color="colors[daysLeft]"></circles-layout>

        <div class="circle-wrapper">
            <div>
                <progress-ring :value="daysLeft" :unit="null" :max="6" :theme="{ stroke: '#fff', track: 'rgba(255,255,255,0.2)', text: '#fff' }" :smooth="true"></progress-ring>
                <p>Dagen</p>
            </div>
            <div>
                <progress-ring :value="hoursLeft" :unit="null" :max="24" :theme="{ stroke: '#fff', track: 'rgba(255,255,255,0.2)', text: '#fff' }" :smooth="true"></progress-ring>
                <p>Uren</p>
            </div>
            <div>
                <progress-ring :value="minutesLeft" :unit="null" :max="60" :theme="{ stroke: '#fff', track: 'rgba(255,255,255,0.2)', text: '#fff' }" :smooth="true"></progress-ring>
                <p>Minuten</p>
            </div>
            <div>
                <progress-ring :value="secondsLeft" :unit="null" :max="60" :theme="{ stroke: '#fff', track: 'rgba(255,255,255,0.2)', text: '#fff' }" :smooth="true"></progress-ring>
                <p>Seconden</p>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import { gsap } from '@/vendor';

    import Circles from '@/app/components/circles';
    import ProgressRing from '@/app/components/progressRing';

    export default {
        name: 'Countdown',
        meta: {
            title: 'Countdown',
            color: '#12C470'
        },

        components: {
            'circles-layout': Circles,
            'progress-ring': ProgressRing
        },

        data()
        {
            return {
                now: new Date(),

                secondsLeft: null,
                minutesLeft: null,
                hoursLeft: null,
                daysLeft: null,

                colors: [
                    'purple', // '#febe06',
                    'orange', // '#fe5d0b',
                    'green', // '#12c470',
                    'blue', // '#36b1ca',
                    'yellow', // '#fe1362',
                    'pink' // '#a5147e'
                ]
            };
        },

        computed: {
            liveDatum()
            {
                return this.$store.getters.liveDatum;
            }
        },

        watch: {
            'now': function( pVal )
            {
                this.calcTime();
            }
        },

        mounted()
        {
            this.calcTime();

            gsap.to({ foo: 0 }, { foo: 1, duration: 1, repeat: -1, onRepeat: this.tick });
        },

        methods: {
            tick()
            {
                this.now = new Date();
            },

            calcTime()
            {
                let totalSecondsLeft = ( this.liveDatum - this.now ) / 1000;
                // console.log( 1, totalSecondsLeft );

                this.daysLeft = Math.floor( totalSecondsLeft / 86400 );
                totalSecondsLeft -= this.daysLeft * 86400;
                // console.log( 2, totalSecondsLeft );
                this.hoursLeft = Math.floor( totalSecondsLeft / 3600 );
                totalSecondsLeft -= this.hoursLeft * 3600;
                // console.log( 3, totalSecondsLeft );

                this.minutesLeft = Math.floor( totalSecondsLeft / 60 );
                totalSecondsLeft -= this.minutesLeft * 60;

                this.secondsLeft = Math.round( totalSecondsLeft );
            }
        }
    };
</script>
